"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _core = require("@material-ui/core");
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _MenuDropdownItem = _interopRequireDefault(require("./MenuDropdownItem.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MenuDropdownItem = function MenuDropdownItem(props) {
  var children = props.children,
    setOpen = props.setOpen;
  var classes = (0, _MenuDropdownItem["default"])();
  var handleMenuItemClick = function handleMenuItemClick() {
    if (children.onClick) {
      children.onClick();
    }
    if (!children.disableClick) {
      setOpen(null);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], _extends({
    className: (0, _clsx["default"])(children.disableHoverEffect ? classes.menuItem : classes.menuItemHover, children.underline && classes.underline),
    onClick: handleMenuItemClick,
    disabled: children.disabled
  }, props.menuItemProps), children.icon && /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, _extends({
    style: {
      marginRight: 10
    },
    color: "#707070",
    size: "1x",
    icon: children.icon
  }, props.dropdownIconStartProps)), children.content, children.arrow && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.iconWrapper
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, _extends({
    color: "rgba(51, 51, 51, 0.5)",
    size: "lg",
    icon: _proRegularSvgIcons.faAngleRight
  }, props.dropDownIconEndProps))));
};
var _default = MenuDropdownItem;
exports["default"] = _default;